__turbopack_context__.v({
  "clientItemwrapper": "clientsList-module-scss-module__zV9wUG__clientItemwrapper",
  "wrapper": "clientsList-module-scss-module__zV9wUG__wrapper",
});
